import {
  ClearOutlined,
  FilterFilled,
  FilterOutlined,
  LayoutOutlined,
  PlusOutlined,
  FormOutlined,
  RobotOutlined,
} from '@ant-design/icons';
import { Checkbox, Dropdown, Menu } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EmpresaTabs } from '../../constants';
import useDispatchWithResult from '../../hooks/useDispatchWithResult';
import { acessoSelector } from '../../store/acessos';
import {
  fetchEmpresas,
  filtradoSelector,
  filtrarEmpresas,
  filtroSelector,
} from '../../store/empresas';
import ActionLink from '../action-link';
import EmpresaDrawer from './_EmpresaDrawer';
import styles from './_styles.less';
import { funcoesSelector } from '../../store/autenticacao';
import { fetchVerificarLimite } from '../../store/empresa';
import unwrapAxiosPromise from '../../util/unwrapAxiosPromise';
import { openPopupEmpresas } from '../../util/window';

export default function SocietarioMenu({ showCreate, showFilter, extraMenu }) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatchWithResult();
  const funcoes = useSelector(funcoesSelector);
  const acesso = useSelector(acessoSelector);
  const filtro = useSelector(filtroSelector);
  const filtrado = useSelector(filtradoSelector);

  const [filterVisible, setFilterVisible] = useState(false);
  const [empresa, setEmpresa] = useState();
  const [empresaDrawerVisible, setEmpresaDrawerVisible] = useState(false);

  const hasCadastro =
    funcoes?.includes('cadastro') &&
    (!acesso || acesso?.funcoes?.includes('cadastro'));

  const handleLimparFiltroClick = ({ domEvent }) => {
    dispatch(
      filtrarEmpresas({
        sucessos: false,
        avisos: false,
        erros: false,
        inativas: false,
        ativas: true,
        tabs: [],
      })
    );
    domEvent.preventDefault();
    return true;
  };

  const handleFilterSucessosChange = ({ domEvent }) => {
    dispatch(filtrarEmpresas({ sucessos: !filtro.sucessos }));
    domEvent.preventDefault();
    return true;
  };

  const handleFilterAvisosChange = ({ domEvent }) => {
    dispatch(filtrarEmpresas({ avisos: !filtro.avisos }));
    domEvent.preventDefault();
    return true;
  };

  const handleFilterErrosChange = ({ domEvent }) => {
    dispatch(filtrarEmpresas({ erros: !filtro.erros }));
    domEvent.preventDefault();
    return true;
  };

  const handleFilterInativasChange = ({ domEvent }) => {
    dispatch(filtrarEmpresas({ inativas: !filtro.inativas }));
    domEvent.preventDefault();
    return true;
  };

  const handleFilterAtivasChange = ({ domEvent }) => {
    dispatch(filtrarEmpresas({ ativas: !filtro.ativas }));
    domEvent.preventDefault();
    return true;
  };

  const handleFilterTabChange = ({ key, domEvent }) => {
    const index = filtro.tabs.indexOf(key);
    if (index < 0) dispatch(filtrarEmpresas({ tabs: [...filtro.tabs, key] }));
    else {
      const newTabs = [...filtro.tabs];
      newTabs.splice(index, 1);
      dispatch(filtrarEmpresas({ tabs: newTabs }));
    }
    domEvent.preventDefault();
    return true;
  };

  const handleLayoutClick = ({ key }) => {
    dispatch(
      filtrarEmpresas({
        sucessos: false,
        avisos: false,
        erros: false,
        inativas: false,
        ativas: true,
        tabs: [],
      })
    );
    history.push(key);
  };

  const handleEmpresaChange = () => {
    dispatch(fetchEmpresas({ acessoId: acesso?.id, modulo: 'societario' }));
  };

  const handleEmpresaDrawerClose = () => {
    setEmpresaDrawerVisible(false);
  };

  const handleEmpresaDrawerAfterClose = () => {
    setEmpresa(undefined);
  };

  const renderFilterTabMenuItem = (tab) => {
    return (
      <Menu.Item key={tab.name} onClick={handleFilterTabChange}>
        <Checkbox checked={filtro.tabs.includes(tab.name)}>
          {t(tab.label)}
        </Checkbox>
      </Menu.Item>
    );
  };

  const buttons = [];
  if (showCreate && hasCadastro) {
    const createMenu = (
      <Menu
        theme="dark"
        onClick={({ key }) => {
          if (key === 'manual') {
            unwrapAxiosPromise(dispatch(fetchVerificarLimite())).then(() => {
              setEmpresa({ acessoId: acesso?.id });
              setEmpresaDrawerVisible(true);
            });
          }
          if (key === 'assistente') {
                openPopupEmpresas()
          }
        }}
      >
        <Menu.Item key="manual" icon={<FormOutlined />}>
          {t('Criar empresa manualmente')}
        </Menu.Item>
        <Menu.Item key="assistente" icon={<RobotOutlined />}>
          {t('Criar empresa por assistente')}
        </Menu.Item>
      </Menu>
    );

    buttons.push(
      <Dropdown
        key="create-dropdown"
        overlay={createMenu}
        trigger={['click']}
        placement="bottomRight"
      >
        <ActionLink
          key="create"
          noTitle
          icon={<PlusOutlined />}
        />
      </Dropdown>
    );
  }
  if (showFilter) {
    const tabsFiltered = EmpresaTabs.filter(
      (tab) => tab.modulos.includes('societario') === true
    ).filter(
      (tab) =>
        funcoes?.includes(tab.name) &&
        (!acesso || acesso?.funcoes?.includes(tab.name))
    );

    buttons.push(
      <Dropdown
        key="filter-dropdown"
        overlay={
          <Menu
            theme="dark"
            mode="horizontal"
            selectable={false}
            disabledOverflow
          >
            <Menu.Item
              key="limpar"
              onClick={handleLimparFiltroClick}
              className={styles['societario-menu-item']}
            >
              <ActionLink
                title={t('Limpar Filtro')}
                icon={<ClearOutlined />}
                disabled={!filtrado}
              />
            </Menu.Item>
            <Menu.ItemGroup
              title={t('Exibir')}
              className={styles['societario-menu-item-group']}
            >
              <Menu.Item key="sucessos" onClick={handleFilterSucessosChange}>
                <Checkbox checked={filtro.sucessos}>{t('Apenas em dia')}</Checkbox>
              </Menu.Item>
              <Menu.Item key="avisos" onClick={handleFilterAvisosChange}>
                <Checkbox checked={filtro.avisos}>{t('Apenas com alertas')}</Checkbox>
              </Menu.Item>
              <Menu.Item key="erros" onClick={handleFilterErrosChange}>
                <Checkbox checked={filtro.erros}>{t('Apenas com pendências')}</Checkbox>
              </Menu.Item>
              <Menu.Item key="inativas" onClick={handleFilterInativasChange}>
                <Checkbox checked={filtro.inativas}>{t('Apenas inativas')}</Checkbox>
              </Menu.Item>
              <Menu.Item key="ativas" onClick={handleFilterAtivasChange}>
                <Checkbox checked={filtro.ativas}>{t('Apenas ativas')}</Checkbox>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.Divider />
            <Menu.ItemGroup
              title={t('Abas')}
              className={styles['societario-menu-item-group']}
            >
              {tabsFiltered.map(renderFilterTabMenuItem)}
            </Menu.ItemGroup>
          </Menu>
        }
        visible={filterVisible}
        onVisibleChange={setFilterVisible}
      >
        <ActionLink
          key="filter"
          icon={filtrado ? <FilterFilled /> : <FilterOutlined />}
          onClick={() => setFilterVisible(true)}
        />
      </Dropdown>
    );
  }

  if (extraMenu && extraMenu.length > 0) buttons.push(extraMenu);
  buttons.push(
    <Dropdown
      key="layout-dropdown"
      overlay={
        <Menu theme="dark" onClick={handleLayoutClick}>
          <Menu.Item key="/societario/dashboard">{t('Painel')}</Menu.Item>
          <Menu.Item key="/societario/tabela">{t('Tabela')}</Menu.Item>
          <Menu.Item key="/societario/detalhado">{t('Detalhado')}</Menu.Item>
          <Menu.Item key="/societario/organograma">{t('Organograma')}</Menu.Item>
        </Menu>
      }
    >
      <ActionLink key="layout" icon={<LayoutOutlined />} />
    </Dropdown>
  );

  return (
    <div className={styles['societario-menu']}>
      {buttons}
      {hasCadastro && (
        <EmpresaDrawer
          value={empresa}
          onChange={handleEmpresaChange}
          visible={empresaDrawerVisible}
          onClose={handleEmpresaDrawerClose}
          onAfterClose={handleEmpresaDrawerAfterClose}
        />
      )}
    </div>
  );
}

SocietarioMenu.propTypes = {
  showCreate: PropTypes.bool,
  showFilter: PropTypes.bool,
  extraMenu: PropTypes.array,
};
